import { connect } from 'react-redux';
import OrderItemList from './order-item-list';
import { orderItemListSelector } from './connect/order-item-list.selector';
import { orderItemListDispatcher } from './connect/order-item-list.dispatcher';
export default connect(orderItemListSelector, orderItemListDispatcher)(OrderItemList);